// extracted by mini-css-extract-plugin
module.exports = {"title":"title__2-uNZ","attribute":"attribute__rfmpy","wrap":"wrap__2jDxj"};